import React from "react";
import { useEffect, useState } from "react";
import {
  BrowserRouter,
  Routes,
  Route,
  useNavigate,
  useLocation,
  Outlet,
} from "react-router-dom";
import { useDispatch } from "react-redux";

import { useSelector } from "react-redux";
//mui
// versionCheck.js
import packageJson from "../../../package.json";

import { styled, useTheme } from "@mui/material/styles";
import useMediaQuery from "@mui/material/useMediaQuery";
import Box from "@mui/material/Box";
import MuiDrawer from "@mui/material/Drawer";
import MuiAppBar from "@mui/material/AppBar";
import Toolbar from "@mui/material/Toolbar";
import List from "@mui/material/List";
import CssBaseline from "@mui/material/CssBaseline";
import Typography from "@mui/material/Typography";
import LogoutIcon from "@mui/icons-material/Logout";
import IconButton from "@mui/material/IconButton";
import MenuIcon from "@mui/icons-material/Menu";
import ChevronLeftIcon from "@mui/icons-material/ChevronLeft";
import ChevronRightIcon from "@mui/icons-material/ChevronRight";

import Grid from "@mui/material/Grid";
import DashboardIcon from "@mui/icons-material/Dashboard";
//local folder
import ProjectRoutes from "../../Routes";
import { removePresist } from "../../Utility/Utilitys";

import {
  MenuAccordion,
  RichObjectTreeView,
} from "./processComponent/LayoutMenuAccordion";
import { LayoutSideMenu, clearSlice } from "./layoutAction";
// import { KernCAConfig } from "../../Redux/roStore";
import "./layout.css";
import { setCartList } from "../cart/sliceCart";
const drawerWidth = 255;

const openedMixin = (theme) => ({
  width: drawerWidth,
  transition: theme.transitions.create("width", {
    easing: theme.transitions.easing.sharp,
    duration: theme.transitions.duration.enteringScreen,
  }),
  overflowX: "hidden",
});

const closedMixin = (theme) => ({
  transition: theme.transitions.create("width", {
    easing: theme.transitions.easing.sharp,
    duration: theme.transitions.duration.leavingScreen,
  }),
  overflowX: "hidden",
  width: `calc(${theme.spacing(7)} + 1px)`,
  [theme.breakpoints.up("sm")]: {
    width: `calc(${theme.spacing(8)} + 1px)`,
  },
});

const DrawerHeader = styled("div")(({ theme }) => ({
  display: "flex",
  alignItems: "center",
  justifyContent: "flex-end",
  padding: theme.spacing(0, 1),
  // necessary for content to be below app bar
  ...theme.mixins.toolbar,
}));

const AppBar = styled(MuiAppBar, {
  shouldForwardProp: (prop) => prop !== "open",
})(({ theme, open }) => ({
  zIndex: theme.zIndex.drawer + 1,
  transition: theme.transitions.create(["width", "margin"], {
    easing: theme.transitions.easing.sharp,
    duration: theme.transitions.duration.leavingScreen,
  }),
  ...(open && {
    marginLeft: drawerWidth,
    width: `calc(100% - ${drawerWidth}px)`,
    transition: theme.transitions.create(["width", "margin"], {
      easing: theme.transitions.easing.sharp,
      duration: theme.transitions.duration.enteringScreen,
    }),
  }),
}));

const Drawer = styled(MuiDrawer, {
  shouldForwardProp: (prop) => prop !== "open",
})(({ theme, open }) => ({
  width: drawerWidth,
  flexShrink: 0,
  whiteSpace: "nowrap",
  boxSizing: "border-box",
  ...(open && {
    ...openedMixin(theme),
    "& .MuiDrawer-paper": openedMixin(theme),
  }),
  ...(!open && {
    ...closedMixin(theme),
    "& .MuiDrawer-paper": closedMixin(theme),
  }),
}));

const Layout = () => {
  const theme = useTheme();
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const location = useLocation();
  const vRdxuserInfo = useSelector((state) => state.login.value);
  const vMediaQuery = useMediaQuery("(max-width:800px)");
  const [sActiveNav, setActiveNav] = useState("/");
  const [sDrawer, setDrawer] = useState(false);
  const menus = useSelector((state) => state.SliceDB.value.menus);

  const fLogout = () => {
    clearSlice(dispatch, navigate);
    navigate("/");
  };

  useEffect(() => {
    setActiveNav(location.pathname);
    if (vMediaQuery) {
      setDrawer(false); // Auto close on mobile/tablet when route changes
    }
  }, [location]);

  const drawerContent = (
    <>
      <DrawerHeader>
        <IconButton onClick={() => setDrawer(false)} sx={{ zIndex: 5 }}>
          {theme.direction === "rtl" ? (
            <ChevronRightIcon />
          ) : (
            <ChevronLeftIcon />
          )}
        </IconButton>
      </DrawerHeader>
      <List sx={{ margiTop: "34px", overflowY: "auto", height: "95vh" }}>
        {vMediaQuery ? (
          <Box sx={{ width: "100%" }} role="presentation">
            <RichObjectTreeView menus={menus} setDrawer={setDrawer} />
          </Box>
        ) : (
          <MenuAccordion
            menus={menus}
            sDrawer={sDrawer}
            setDrawer={setDrawer}
            sActiveNav={sActiveNav}
            setActiveNav={setActiveNav}
          />
        )}
      </List>
    </>
  );

  return (
    <Box sx={{ display: "flex" }} className="main-layout">
      <CssBaseline />
      <AppBar
        // position="fixed" open={sDrawer}
        position={vMediaQuery ? "absolute" : "fixed"}
        open={sDrawer}
        sx={{
          zIndex: (theme) => theme.zIndex.drawer + 1,
          ...(vMediaQuery && {
            width: "100%",
            backgroundColor: (theme) => theme.palette.primary.main,
          }),
        }}
      >
        <Toolbar>
          <Box sx={{ flexGrow: 1 }}>
            <Grid container columns={{ xs: 12, sm: 12, md: 12 }}>
              <Grid
                item
                xs={6}
                sx={{
                  display: "flex",
                  alignItems: "center",
                }}
              >
                {vMediaQuery ? (
                  <MenuIcon
                    onClick={() => {
                      // navigate("/");
                      setDrawer((prev) => !prev);
                    }}
                    sx={{
                      marginRight: 1,
                    }}
                  />
                ) : (
                  <IconButton
                    color="inherit"
                    aria-label="open drawer"
                    // onClick={fDrawerOpen}
                    onClick={() => setDrawer(true)}
                    edge="start"
                    sx={{
                      marginRight: 5,
                      ...(sDrawer && { display: "none" }),
                    }}
                  >
                    <MenuIcon />
                  </IconButton>
                )}

                <Typography variant="h6" noWrap component="div">
                  WMSWeb - {packageJson.version}
                </Typography>
              </Grid>
              <Grid
                item
                xs={6}
                sx={{
                  display: "flex",
                  alignItems: "center",
                  justifyContent: "end",
                }}
                className="userLogo"
              >
                <Typography
                  variant="h6"
                  noWrap
                  component="div"
                  onClick={() => {
                    removePresist();
                    dispatch(setCartList([]));
                  }}
                >
                  <span
                    id="logout"
                    onClick={() => {
                      navigate("/");
                      fLogout();
                    }}
                  >
                    {vRdxuserInfo?.UserName} &nbsp;
                    <LogoutIcon />
                  </span>
                </Typography>
              </Grid>
            </Grid>
          </Box>
        </Toolbar>
      </AppBar>
      {vMediaQuery ? (
        <MuiDrawer
          anchor="left"
          open={sDrawer}
          onClose={() => setDrawer(false)}
          ModalProps={{
            keepMounted: true, // Better performance on mobile
          }}
          sx={{
            "& .MuiDrawer-paper": {
              width: "100%",
              boxSizing: "border-box",
              zIndex: 100,
            },
          }}
        >
          {drawerContent}
        </MuiDrawer>
      ) : (
        <Drawer variant="permanent" open={sDrawer} className="Drawer">
          {drawerContent}
        </Drawer>
      )}
      <Box
        component="main"
        sx={{
          flexGrow: 1,
          padding: {xs:"20px 4px 2px 0px",sm:"40px 4px 2px 0px"},
          overflowX: "hidden",
          height: "100vh",
        }}
      >
        <DrawerHeader />
        <Box sx={{ mt: 1 }}>
          <Outlet />
        </Box>
      </Box>
    </Box>
  );
};

export default Layout;
